import { render, staticRenderFns } from "./ODriverInfo.vue?vue&type=template&id=10fab1cc&"
import script from "./ODriverInfo.vue?vue&type=script&lang=js&"
export * from "./ODriverInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports